import { Component, Inject, OnInit } from '@angular/core';
import { ICase } from 'src/app/modules/cases/interfaces/case.interface';
import { TaskCase } from 'src/app/modules/case/interface/task.interface';
import { TaskService } from '../../services/task.service';
import { CaseRecordService } from '../../services/case-record.service';
import { TaskCaseService } from '../../services/taskCase.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ICaseType } from 'src/app/modules/unit/interfaces/case-type.interface';
import { subscribeOn } from 'rxjs/operators';
@Component({
  selector: 'app-add-task-case',
  templateUrl: './add-task-case.component.html',
  styleUrls: ['./add-task-case.component.scss'],
})
export class AddTaskCaseComponent implements OnInit {
  case: ICase = null;
  search: string = '';
  tasks: TaskCase[] = null;
  originalTask: TaskCase[] = [];
  caseType: ICaseType;

  taskSelected = [];

  constructor(
    public taskService: TaskService,
    public caseRecordService: CaseRecordService,
    public taskCaseService: TaskCaseService,
    public dialogRef: MatDialogRef<AddTaskCaseComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ICase,
    private _snackBar: MatSnackBar
  ) {}

  close() {
    this.dialogRef.close();
  }

  addToSelected(task: TaskCase) {
    this.tasks = this.tasks.filter((tarea) => tarea._id !== task._id);
    this.taskSelected.push(task);
  }

  removeFromSelected(task: TaskCase) {
    this.taskSelected = this.taskSelected.filter(
      (tarea) => tarea._id !== task._id
    );
    this.tasks.push(task);
  }

  ngOnInit() {
    this.case = this.data;
    this.caseType = this.data.caseType;

    // Obteniendo las tareas por unidad
    this.taskService
      .byCaseType(this.caseType._id)
      .subscribe((task: TaskCase[]) => {
        // Creando propiedad checked para las tareas y sus checkboxes
        for (let i in task) task[i].checked = false;

        // Habilitar checkbox de tareas con campo requerido activado
        task.map((task) => {
          if (task.required) {
            this.changeCheck({ checked: true }, task);
          }
        });

        this.obtenerTareasSeleccionadas();
      });
  }

  obtenerTareasSeleccionadas() {
    this.taskService
      .byCaseType(this.caseType._id)
      .subscribe((tasks: TaskCase[]) => {
        // Filtra las tareas para que ninguna sea requerida
        tasks = tasks.filter((task: TaskCase) => task.required != true);

        this.tasks = tasks;
        this.taskCaseService
          .getTaskByCaseId(this.data._id)
          .subscribe((response: TaskCase[]) => {
            for (let i in response) {
              // Habilitando los checkboxes de las tareas actuales
              var indexg: number;
              const task = this.tasks.find((task, index) => {
                indexg = index;
                return task.title === response[i].title;
              });
              if (task) {
                task.checked = true;
                if (!task.checked && task) this.tasks[indexg] = task;
                else {
                  this.tasks.splice(indexg, 1);
                  this.deleteTareaFromArray(task.title);
                }
              }
            }
          });
      });
  }

  deleteTareaFromArray(title: string) {
    this.tasks = this.tasks.filter((task: TaskCase) =>
      task.title !== title ? true : false
    );
    this.originalTask = this.originalTask.filter((task: TaskCase) =>
      task.title !== title ? true : false
    );
  }

  async changeCheck(event: any, task: TaskCase) {
    if (event.checked) {
      const taskCase: any = await this.taskCaseService
        .createTaskCase({
          title: task.title,
          case: this.data._id,
          task: task._id,
          status: 'pending',
          description: task.description,
          required: task.required,
          component: task.component,
          requiresFiles: task.requiresFiles,
          requiresObservations: task.requiresObservations,
          deleted: false,
        })
        .toPromise();
      if (
        taskCase.msj !== 'La tarea ya esta asociada al caso' &&
        !task.required
      )
        this.openSnackBar(taskCase.msj, 'x');
      if (taskCase.msj === 'Tarea agregada al caso') {
        this.taskCaseService.taskCreated.next(taskCase.newTaskCase);
        // await this.caseRecordService.createCaseRecord({
        //   case: this.case._id,
        //   user: `62b0fbb862557033145dbd4e`, //TODO: Cambiar a id usuaio
        //   action: `Agrego la tarea "${task.title}" a la columna "Pendiente por realizar"`,
        // });
      }
    }
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action);
  }

  addTasks() {
    this.taskSelected.map(async (task) => {
      await this.changeCheck({ checked: true }, task);
    });
    this.dialogRef.close();
  }

  filter() {
    if (this.originalTask.length === 0) this.originalTask = this.tasks;
    this.tasks = this.originalTask;
    this.tasks = this.tasks.filter(
      (tarea) =>
        JSON.stringify(tarea)
          .toLowerCase()
          .indexOf(this.search.toLowerCase()) !== -1
    );
  }
}
